export default __webpack_public_path__ + "static/media/banner-model.aec04445.svg";